import Glide from '../vendors/glide.min';

const gridSliders = () => {
  const gridSliderItems = document.querySelectorAll('.grid-slider');
  if (gridSliderItems.length === 0) {
    return;
  }

  const updateBullets = () => {
    [].map.call(gridSliderItems, (slider) => {
      const bullets = slider.querySelectorAll('.glide__bullet');
      const { innerWidth } = window;
      bullets.forEach((bullet, index) => {
        const shouldShow =
          (innerWidth > 992 && index <= bullets.length - 3) ||
          (innerWidth <= 992 && innerWidth > 576 && index <= bullets.length - 2) ||
          (innerWidth <= 576);
        bullet.classList.toggle('hidden', !shouldShow);
      });
    });
  };

  const init = () => {
    [].map.call(gridSliderItems, (slider) => {
      if (slider.querySelectorAll('.glide__slide').length > 1) {
        const glide = new Glide(slider, { /* eslint-disable-line no-unused-vars */
          bound: true,
          breakpoints: {
            992: {
              perView: 2,
            },
            576: {
              perView: 1,
            },
          },
          perView: 3,
          rewind: false,
          startAt: 0,
          type: 'slider',
        });
        window.addEventListener('resize', () => {
          updateBullets();
          glide.go('=0');
        });
        updateBullets();
        glide.mount();
      }
    });
  };
  init();
};

export default gridSliders;
